module.exports = __webpack_public_path__ + "static/img/MA.24fca0b4.png";